import React from "react"
import styled from "styled-components"
import Form from "./form"
import Grid from "../grid"
import Breakpoints from "../breakpoints"
import { T } from "../typography.styles"

const Container = styled.div`
  padding: 48px 0;
  @media (min-width: ${Breakpoints.md}) {
    padding: 64px 0 48px;
  }
  @media (min-width: ${Breakpoints.lg}) {
    padding: 96px 0 128px;
  }
`

export const SubHeading = styled.p`
  ${T.sm.misc.subheading}
  font-size: 14px;
  color: var(--burnt-orange);
  grid-column: 1 / -1;
  width: 100%;
  text-align: center;
  @media (min-width: ${Breakpoints.md}) {
    ${T.lg.h5.regular}
    font-size: 18px;
  }
`
export const Title = styled.h2`
  ${T.sm.h1.regular}
  color: #17191d;
  grid-column: 1 / -1;
  width: 100%;
  text-align: center;
  margin-top: 16px;

  @media (min-width: ${Breakpoints.md}) {
    ${T.lg.h1.regular}
  }
`

const StyledForm = styled(Form)`
  grid-column: 1 / -1;
  margin-top: 48px;
  @media (min-width: ${Breakpoints.md}) {
    grid-column: 3 / -3;
    margin-top: 96px;
  }
  @media (min-width: ${Breakpoints.lg}) {
    grid-column: 4 / -4;
    padding: 0 calc(100% / 14);
  }
`

export default function PartnerFormLayout(props) {
  return (
    <Container>
      <Grid id="contact-form">
        <SubHeading>Interested in becoming a Mappedin partner?</SubHeading>
        <Title>Join Us Today</Title>
        <StyledForm />
      </Grid>
    </Container>
  )
}
